import EditProviderBotContainer from './edit-provider-bot-container';

export default EditProviderBotContainer;
